import React, { memo } from 'react';
export function TestimonialsSection() {
  const testimonials = [{
    quote: 'I used to take dozens of photos and still feel disappointed. After following the angle and light tips, I finally got photos that actually feel like my dog.',
    name: 'Emily',
    location: 'Austin'
  }, {
    quote: "This made dog photography feel simple for the first time. I'm not a photographer at all, but now my photos look warmer, clearer, and much more intentional.",
    name: 'Rachel',
    location: 'Miami'
  }, {
    quote: 'I bought this because I wanted better memories of my senior dog. It helped me capture moments that actually feel worth keeping.',
    name: 'Daniel',
    location: 'Manchester'
  }, {
    quote: 'Very practical, very beginner-friendly, and not overloaded with technical jargon. Exactly what I needed.',
    name: 'Sophie',
    location: 'Sydney'
  }];
  return <section className="bg-warm-light py-16 md:py-24 px-4" data-id="element-300">
      <div className="max-w-3xl mx-auto" data-id="element-301">
        {/* Heading */}
        <h2 className="font-serif text-3xl md:text-4xl lg:text-5xl font-bold text-center text-warm-hero mb-12 leading-tight" data-id="element-302">
          What dog owners are{' '}
          <span className="italic text-soft-gold" data-id="element-303">saying</span>
        </h2>

        {/* Testimonials */}
        <div className="space-y-6" data-id="element-304">
          {testimonials.map((t, index) => <div key={index} className="bg-white p-6 md:p-8 rounded-xl border border-soft-gold/10 shadow-sm relative" data-id="element-305">
              {/* Quote mark */}
              <div className="text-soft-gold text-5xl absolute top-3 left-5 opacity-15 font-serif leading-none" data-id="element-306">
                "
              </div>

              {/* Stars */}
              <div className="flex text-orange mb-3 text-sm" data-id="element-307">
                {'★★★★★'.split('').map((star, i) => <span key={i} data-id="element-308">{star}</span>)}
              </div>

              {/* Quote */}
              <p className="font-sans text-base md:text-lg text-gray-800 italic mb-4 relative z-10 leading-relaxed" data-id="element-309">
                "{t.quote}"
              </p>

              {/* Attribution */}
              <p className="font-sans text-sm text-gray-500 font-medium" data-id="element-310">
                — {t.name}, {t.location}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}